import React, { useState, useEffect } from "react";

//Import Breadcrumb
import { Grid, Typography } from "@mui/material";
import { connect } from 'react-redux';
import CustomButton from "../../../components/Form/CustomButton";
import CustomIconButton from "../../../components/Form/CustomIconButton";
import CustomSelect from "../../../components/Form/CustomSelect";
import CustomAutocomplete from "../../../components/Form/CustomAutocomplete";
import "../../Orders/order.css";
import Table from "./Table";

const GiftField = ({ tempGift, error, setTempGift, handleAddProduct, setTempProduct, setData, data, tempProduct, productListing, handleDeleteGift, tempGiftEmpty }) => {
    const [isSorted, setSorted] = useState(false)
    const [isSortedDesc, setSortedDesc] = useState(false)

    const header = [
        {
            Header: "Product",
            columnID: "gift_product_name",
            minWidth: "90%",
            accessor: "gift_product_name", // Directly access the gift_product_name field
            Cell: ({ cell, idx }) => {
                const cellProps = cell.row.original; // Access the entire row's data
                return (
                    <React.Fragment>
                        <Typography sx={{ '&:hover': { color: "#7BB9FA" } }}> {cellProps?.gift_product_name} </Typography>
                        <Typography sx={{ fontSize: "14px", fontWeight: 400, color: "#999999" }}>Category: {cellProps?.gift_category_names?.length > 1 ? cellProps?.gift_category_names?.map((x, idx) => `${x}${idx !== cellProps?.gift_category_names?.length - 1 ? ", " : ""}`) : cellProps?.gift_category_names} </Typography>
                        <Typography sx={{ fontSize: "14px", fontWeight: 400, color: "#999999" }}>Price: <span style={{ textDecoration: "line-through", textDecorationColor: "#282828" }}>S$ {cellProps?.gift_aspeed_price} </span> &nbsp; <span style={{ color: "#282828" }}>S$0.00</span></Typography>
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Action",
            minWidth: "10%",
            accessor: (cellProps, idx) => {
                return (
                    <React.Fragment>
                        <div className="pt-2">
                            <CustomIconButton
                                iconName={'ri-delete-bin-line'}
                                onClick={(e) => handleDeleteGift(idx)}
                                backgroundColor={'#44d62c'}
                                color={'white'}
                                borderStyle={"1px solid #44d62c"}
                            />
                        </div>
                    </React.Fragment>
                )
            },
            position: 'sticky',
            disableFilters: true,
            filterable: false,
        }
    ]

    const handleSort = (columnID) => {
        // Sort the data based on the column and direction
        const sorted = [...data].sort((a, b) => {
            const aValue = a[columnID];
            const bValue = b[columnID];

            // Check if the values are strings
            if (typeof aValue === 'string' && typeof bValue === 'string') {
                return isSortedDesc
                    ? bValue.localeCompare(aValue)  // Sort in descending order
                    : aValue.localeCompare(bValue);  // Sort in ascending order
            }

            // Check if the values are numbers
            if (typeof aValue === 'number' && typeof bValue === 'number') {
                return isSortedDesc ? bValue - aValue : aValue - bValue;  // Sort numerically
            }

            return 0;  // If data types are different or unsupported, do not change the order
        });

        // Update the state with the sorted data
        setData(sorted);

    };

    return (
        <div>
            < Grid container spacing={2} pb={2}>
                <Grid item xs={9} sm={10.5} pb={3}>
                    <CustomAutocomplete
                        title={"Gifts Products"}
                        values={tempProduct?.product_id}
                        valueName={"id"}
                        labelName={"name"}
                        style={{
                            // Adjust width as needed
                            '& input::placeholder': {
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            },
                        }}
                        placeholder={"Search for a product to add as a product gifts"}
                        onChange={(e, value) => {
                            setTempProduct({ product_id: value?.id })
                        }}
                        error={error && error?.tempProduct}
                        data={productListing}
                    />
                </Grid>
                <Grid item xs={3} sm={1.5} alignItems={"flex-end"} display={"flex"} >
                    <div className="pb-4">
                        <CustomButton
                            title={'Add'}
                            press={() => handleAddProduct()}
                            height={40}
                            backgroundColor={'#101010'}
                            textColor={'white'}
                        />
                    </div>
                </Grid>
            </Grid >
            <Table
                header={header}
                data={data}
                totalPage={1}
                pageSize={data?.length}
                customToolsBar={true}
                module={'configuration-list'}
                isSorted={isSorted}
                isSortedDesc={isSortedDesc}
                setSorted={setSorted}
                setSortedDesc={setSortedDesc}
                handleSort={handleSort}
                categoryList={[{ label: 'Laptop', value: 'laptop' }, { label: 'Monitor', value: 'monitor' }]}
            />
        </div>

    );
};

function mapStateToProps({ }) {
    return {

    };
}


export default connect(mapStateToProps)(GiftField);
